<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: 'welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>轮播管理</el-breadcrumb-item>
      <el-breadcrumb-item>轮播列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
      <!-- 搜索区域 -->
      <div class="search-wrapper">
        <div class="search-toggle" v-show="isMobile" @click="toggleSearch">
        <i :class="isSearchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        <span>{{ isSearchExpanded ? '收起筛选' : '展开筛选' }}</span>
      </div>
      <div class="search-content" :class="{ 'search-content-mobile': isMobile }" v-show="!isMobile || isSearchExpanded">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-input 
                placeholder="请输入轮播标题" 
                v-model="searchQuery.title_cn" 
                clearable 
                @clear="fetchBanners()" 
                size="medium">
                <el-button slot="append" icon="el-icon-search" @click="fetchBanners()"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-select v-model="searchQuery.status" placeholder="显示状态" @change="fetchBanners()" size="medium">
                <el-option :value="1" label="显示"></el-option>
                <el-option :value="0" label="隐藏"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-button type="default" @click="resetSearch()" size="medium">重置</el-button>
              <el-button type="primary" @click="createBanner()" size="medium" plain>创建轮播</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 轮播列表 -->
      <div class="table-scroll-wrapper">
        <el-table :data="bannerList" style="width: 100%" border stripe>
        <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
        <el-table-column label="标题" prop="title_cn" align="center"></el-table-column>
        <el-table-column label="封面图" width="180" align="center">
          <template slot-scope="scope">
            <el-image class="cover-image" :src="`${imageURL}${scope.row.cover_cn}`" :preview-src-list="[`${imageURL}${scope.row.cover_cn}`]" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="跳转类型" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.link_url ? 'primary' : 'success'">
              {{ scope.row.link_url ? '跳转链接' : '跳转详情' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '显示' : '隐藏' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="viewBanner(scope.row.banner_id)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onPageChange"
          :current-page="pageNum"
          :page-sizes="[1, 2, 5, 10]"
          :page-size="pageSize"
          :layout="isMobile ? 'total, sizes, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { IMAGE_URL } from '@/utils/urls'

export default {
  name: 'Banners',
  data() {
    return {
      isSearchExpanded: false,
      isMobile: false,
      imageURL: IMAGE_URL,
      bannerList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchQuery: {
        status: null,
        title_cn: ''
      }
    }
  },
  created() {
    this.fetchBanners()
    this.checkIsMobile()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    fetchBanners() {
      this.$http({
        method: 'get',
        url: 'banners/banners',
        params: {
          ...this.searchQuery,
          page: this.pageNum,
          size: this.pageSize
        }
      }).then(res => {
        if (!res.success) return this.$message.error(res.message)
        this.bannerList = res.data
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.response?.data?.message || '获取轮播列表失败')
      })
    },

    resetSearch() {
      this.searchQuery = { 
        status: null,
        title_cn: ''
      }
      this.fetchBanners()
    },

    onSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchBanners()
    },

    onPageChange(newPage) {
      this.pageNum = newPage
      this.fetchBanners()
    },

    viewBanner(id) {
      this.$router.push(`/admin/banner/details/${id}`)
    },

    createBanner() {
      this.$router.push('/admin/banner/create')
    },

    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded
    },

    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768
    },

    handleResize() {
      const wasMobile = this.isMobile
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile && wasMobile) {
        this.isSearchExpanded = false
      }
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-top: 15px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 15px;
}

.table-scroll-wrapper .el-table {
  min-width: 100%;
}

.pagination-wrapper {
  margin-top: 15px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
}

.pagination-wrapper .el-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 10px 0;
  min-width: max-content;
}

.cover-image {
  width: 150px;
  height: 80px;
  border-radius: 5px;
}

.search-wrapper {
  margin-bottom: 10px;
}

.search-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s;
}

.search-toggle:hover {
  color: #409eff;
}

.search-toggle i {
  font-size: 14px;
}

.search-content {
  padding-top: 10px;
}

@media (max-width: 768px) {
  .el-card {
    margin-top: 10px;
    padding: 10px;
  }

  .table-scroll-wrapper {
    margin-top: 10px;
  }

  .table-scroll-wrapper .el-table {
    font-size: 11px;
  }

  .table-scroll-wrapper .el-table th,
  .table-scroll-wrapper .el-table td {
    padding: 8px 5px !important;
  }

  .table-scroll-wrapper .el-button--small {
    font-size: 11px;
  }

  .pagination-wrapper {
    margin-top: 10px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
  }

  .pagination-wrapper .el-pagination {
    font-size: 10px;
    justify-content: flex-start;
    min-width: max-content;
  }

  .pagination-wrapper .btn-prev,
  .pagination-wrapper .btn-next {
    width: 26px;
    height: 26px;
    line-height: 26px;
    font-size: 11px;
    padding: 0;
  }

  .pagination-wrapper .el-pager li {
    padding: 0 2px;
    min-width: 22px;
    height: 26px;
    line-height: 26px;
    font-size: 10px;
  }

  .pagination-wrapper .el-pagination__total {
    font-size: 10px;
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes {
    margin-right: 8px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input {
    width: 60px;
  }

  .pagination-wrapper .el-pagination__sizes .el-input__inner {
    height: 24px;
    font-size: 10px;
    padding: 0 5px;
  }

  .search-content-mobile .el-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-content-mobile .el-row .el-col {
    width: 100% !important;
    margin-bottom: 5px;
  }

  .search-content-mobile .el-input,
  .search-content-mobile .el-select {
    width: 100%;
  }

  .search-toggle {
    padding: 10px 0;
    font-size: 13px;
  }

  .cover-image {
    width: 100px;
    height: 50px;
  }
}
</style>
